import { Link } from "react-router-dom";


export default function PaginaDos() {
return (
<div className="text-center">
<h2 className="subtitle-arial mb-4">Subtítulo de la Página Dos</h2>


<p className="text-lg mb-6">Has navegado con éxito 🎉</p>
<Link
to="/"
className="px-6 py-3 rounded-2xl shadow bg-green-500 text-white hover:bg-green-600 transition"
>
Regresar a Inicio
</Link>
</div>
);
}